(function () {
  'use strict';
  function chooseLanguage(languages, available, saved) {
    if (available.includes(saved)) return saved;
    for (const language of languages || []) {
      const code = String(language).toLowerCase().split('-')[0];
      if (available.includes(code)) return code;
    }
    return available.includes('en') ? 'en' : available[0];
  }
  function shouldAuto(path, explicit, detected, editor, local) {
    if (explicit || detected || editor) return false;
    return local ? /\/(?:index\.html)?$/.test(path) : path === '/';
  }
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { chooseLanguage, shouldAuto };
    return;
  }
  function setup() {
    const form = document.querySelector('[data-naturalis-language]');
    if (!form || form.dataset.initialized) return;
    form.dataset.initialized = 'true';
    const select = form.querySelector('select[name="language_code"]');
    if (!select) return;
    const automaticOption = select.querySelector('option[value="auto"]');
    if (automaticOption) automaticOption.hidden = false;
    const available = Array.from(select.options).map(option => option.value).filter(value => value !== 'auto');
    const local = form.dataset.mode === 'local';
    const current = document.documentElement.lang.split('-')[0];
    const url = new URL(window.location.href);
    function navigate(code, manual) {
      if (!available.includes(code)) return;
      if (code === current) { select.value = code; return; }
      if (local) {
        const file = code === 'de' ? 'index.html' : code + '.html';
        const next = new URL(file, window.location.href);
        next.search = url.search;
        next.searchParams.set('nlang', code);
        next.hash = url.hash;
        window.location.replace(next.href);
      } else {
        select.value = code;
        let returnTo = form.querySelector('[name="return_to"]');
        if (!returnTo) { returnTo = document.createElement('input'); returnTo.type = 'hidden'; returnTo.name = 'return_to'; form.appendChild(returnTo); }
        const params = new URLSearchParams(url.search);
        params.set('nlang', code);
        returnTo.value = url.pathname + '?' + params.toString() + url.hash;
        HTMLFormElement.prototype.submit.call(form);
      }
    }
    function applySelection(event) {
      event.preventDefault();
      if (select.value === 'auto') {
        navigate(chooseLanguage(navigator.languages || [navigator.language], available, null), false);
      } else { navigate(select.value, true); }
    }
    form.addEventListener('submit', applySelection);
    select.addEventListener('change', applySelection);
    const editor = Boolean(window.Shopify && window.Shopify.designMode);
    if (shouldAuto(url.pathname, url.searchParams.has('nlang') || url.searchParams.has('contact_posted'), false, editor, local)) {
      const preferred = chooseLanguage(navigator.languages || [navigator.language], available, null);
      if (preferred && preferred !== current) navigate(preferred, false);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
  document.addEventListener('shopify:section:load', setup);
})();
